<div class="oowl-page">
  <div class="oowl-head">
    <h2>On Our Way Log</h2>
    <div class="oowl-sub">Jobs that showed the schedule card's On Our Way button (Builder confirmed, GRV / ASH), how many were pressed, and each press with the rater's first clock-in on that job afterwards.</div>
  </div>

  <div class="oowl-controls">
    <label>From <input type="date" [(ngModel)]="from" (change)="load()"></label>
    <label>To <input type="date" [(ngModel)]="to" (change)="load()"></label>
    <label>Regions
      <select multiple [(ngModel)]="selectedRegions" (change)="onRegionsChange()" class="oowl-multi" [size]="regions.length > 6 ? 6 : (regions.length || 1)">
        <option *ngFor="let r of regions" [value]="r">{{ r }}</option>
      </select>
    </label>
    <label>Raters
      <select multiple [(ngModel)]="selectedRaters" (change)="load()" class="oowl-multi oowl-multi-wide" [size]="raterOptions.length > 6 ? 6 : (raterOptions.length || 1)">
        <option *ngFor="let r of raterOptions" [ngValue]="r.employee_id">{{ r.employee_name }}<span *ngIf="r.region"> ({{ r.region }})</span></option>
      </select>
    </label>
    <button class="oowl-btn" (click)="load()" [disabled]="loading">{{ loading ? 'Loading…' : 'Refresh' }}</button>
    <button class="oowl-btn" (click)="clearFilters()" [disabled]="loading || (!selectedRegions.length && !selectedRaters.length)">Clear filters</button>
    <button class="oowl-btn" (click)="exportJobsCsv()" [disabled]="loading || !jobs.length">Export jobs CSV</button>
    <button class="oowl-btn" (click)="exportCsv()" [disabled]="loading || !rows.length">Export presses CSV</button>
    <span class="oowl-muted" *ngIf="updatedAt">Last updated {{ updatedAt | date:'h:mm a' }}</span>
  </div>

  <div class="oowl-error" *ngIf="error">{{ error }}</div>

  <div class="oowl-label">Button availability (by schedule date)</div>
  <div class="oowl-tiles">
    <div class="oowl-tile"><div class="n">{{ stats.available }}</div><div class="l">Jobs with the button</div></div>
    <div class="oowl-tile" [ngClass]="'rate-' + rateClass(stats.rate)">
      <div class="n">{{ stats.pressedJobs }} <span class="of">of {{ stats.available }}</span> <span class="pct">{{ fmtRate(stats.rate) }}</span></div>
      <div class="l">Pressed</div>
    </div>
    <div class="oowl-tile" [class.warn]="stats.hidden > 0"><div class="n">{{ stats.hidden }}</div><div class="l">Hidden: no textable contact</div></div>
  </div>

  <div class="oowl-label">Presses (by press date)</div>
  <div class="oowl-tiles">
    <div class="oowl-tile"><div class="n">{{ stats.presses }}</div><div class="l">Button presses</div></div>
    <div class="oowl-tile"><div class="n">{{ stats.withClockin }}</div><div class="l">With a clock-in after</div></div>
    <div class="oowl-tile"><div class="n">{{ stats.avgMinutes === null ? '—' : fmtMinutes(stats.avgMinutes) }}</div><div class="l">Average press → clock-in</div></div>
    <div class="oowl-tile" [class.warn]="stats.presses - stats.withClockin > 0"><div class="n">{{ stats.presses - stats.withClockin }}</div><div class="l">No clock-in yet</div></div>
  </div>

  <ng-container *ngIf="perRater.length">
    <div class="oowl-label">By rater</div>
    <div class="oowl-card">
      <table class="oowl-table">
        <thead><tr><th>Rater</th><th>Region</th><th class="num">Available</th><th class="num">Pressed</th><th class="num">Rate</th><th class="num">Presses</th><th class="num">With clock-in</th><th class="num">Average</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of perRater">
            <td>{{ s.employee_name || ('#' + s.employee_id) }}</td>
            <td>{{ s.region }}</td>
            <td class="num">{{ s.available }}</td>
            <td class="num">{{ s.pressedJobs }}</td>
            <td class="num rate" [ngClass]="rateClass(s.rate)">{{ fmtRate(s.rate) }}</td>
            <td class="num">{{ s.presses }}</td>
            <td class="num">{{ s.withClockin }}</td>
            <td class="num">{{ s.avgMinutes === null ? '—' : fmtMinutes(s.avgMinutes) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="perDay.length">
    <div class="oowl-label">By day</div>
    <div class="oowl-card">
      <table class="oowl-table">
        <thead><tr><th>Schedule date</th><th class="num">Available</th><th class="num">Pressed</th><th class="num">Rate</th><th class="num">Hidden</th></tr></thead>
        <tbody>
          <tr *ngFor="let d of perDay; trackBy: trackDay">
            <td class="nowrap">{{ d.date }}</td>
            <td class="num">{{ d.available }}</td>
            <td class="num">{{ d.pressedJobs }}</td>
            <td class="num rate" [ngClass]="rateClass(d.rate)">{{ fmtRate(d.rate) }}</td>
            <td class="num">{{ d.hidden }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <div class="oowl-label">Jobs with the button</div>
  <div class="oowl-empty" *ngIf="!loading && !error && !jobs.length">No eligible jobs in this range.</div>
  <div class="oowl-card" *ngIf="jobs.length">
    <table class="oowl-table">
      <thead>
        <tr>
          <th>Schedule date</th><th>Rater</th><th>Region</th><th>Subdivision</th><th>Lot</th><th>Street</th><th>Job Type</th><th>Contact</th>
          <th>Button</th><th>Pressed</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let j of jobs; trackBy: trackJob" [class.hidden-row]="!j.available">
          <td class="nowrap">{{ j.schedule_date }}</td>
          <td class="nowrap">{{ j.employee_name || '—' }}</td>
          <td>{{ j.region }}</td>
          <td>{{ j.subdivision_name }}</td>
          <td>{{ j.lot }}</td>
          <td>{{ j.street_address }}</td>
          <td>{{ j.job_type }}</td>
          <td>{{ j.contact_name || '—' }}</td>
          <td class="nowrap" [ngClass]="j.available ? 'shown' : 'hidden'">{{ j.available ? 'Shown' : 'Hidden: ' + j.hidden_reason }}</td>
          <td class="nowrap" [ngClass]="j.pressed ? 'yes' : (j.available ? 'no' : 'none')">{{ j.pressed ? ('Yes · ' + fmtTime(j.first_press_at, null)) : (j.available ? 'No' : '—') }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="oowl-label">Presses</div>
  <div class="oowl-empty" *ngIf="!loading && !error && !rows.length">No presses in this range.</div>
  <div class="oowl-card" *ngIf="rows.length">
    <table class="oowl-table">
      <thead>
        <tr>
          <th>Pressed</th><th>Rater</th><th>Region</th><th>Contact</th><th>Street</th><th>Subdivision</th><th>Lot</th><th>Job Type</th>
          <th>First Clock-in</th><th class="num">Diff</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows; trackBy: trackRow">
          <td class="nowrap">{{ fmtTime(r.pressed_at, r.pressed_tz) }}</td>
          <td class="nowrap">{{ r.employee_name }}</td>
          <td>{{ r.region }}</td>
          <td>{{ r.contact_name }}</td>
          <td>{{ r.street_address }}</td>
          <td>{{ r.subdivision_name }}</td>
          <td>{{ r.lot }}</td>
          <td>{{ r.job_type }}</td>
          <td class="nowrap">{{ r.first_clockin ? fmtTime(r.first_clockin, r.pressed_tz) : '—' }}</td>
          <td class="num diff" [ngClass]="diffClass(r.diff_minutes)">{{ r.diff_minutes === null ? '—' : fmtMinutes(r.diff_minutes) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
